<div (copy)="blockCopy()" (cut)="blockCut()" appBlockPrint class="no-print">
  <h1 class="page-title">Terms and Conditions</h1>
  <p><strong>I will</strong></p>
  <ul>
    <li>submit answers that are mine alone.</li>
    <li>access content when needed to help me choose an answer.</li>
  </ul>
  <p><strong>I will not</strong></p>
  <ul>
    <li>accept help from any other person.</li>
    <li>copy, disclose, or distribute any part or portion of the assessment.</li>
    <li>violate these terms because doing so could initiate an investigation into potential misconduct by the Judicial
      and
      Ethics Committee.</li>
  </ul>
  <form (submit)="accept()">
    <div class="form-actions form-actions--reverse">
      <button type="submit" class="button form-actions__item" value="I Agree">I Agree</button>
      <a routerLink="/assessment" class="button button--bare form-actions__item">Back to Dashboard</a>
    </div>
  </form>
</div>